import { Injectable } from "@angular/core";
import { MapperInterface } from "../mapper-inteface";
import { EntitaAnagrafeVO } from "@app/shared/vo/gescor/entita-anagrafeVO";
import { SoggettoAnagrafeDTO } from "@app/shared/dto/anagrafe/soggetto-anagrafeDTO";
import { EntitaAnagrafeEstesaDTO } from "@app/shared/dto/anagrafe/entita-anagrafe-estesaDTO";


@Injectable({
    providedIn: "root"
  })
export class MapperEntitaAnagrafeEstesa
  implements MapperInterface<EntitaAnagrafeEstesaDTO, EntitaAnagrafeVO> {
  constructor() {}

  convertVoToDto(e: EntitaAnagrafeVO): EntitaAnagrafeEstesaDTO {
    throw new Error("Method not implemented.");
  }

  convertDtoToVo(dto: EntitaAnagrafeEstesaDTO): EntitaAnagrafeVO {
    const vo = new EntitaAnagrafeVO();
    vo.idSoggetto = String(dto.idSoggetto);
    vo.idRecapito = String(dto.idRecapito);
    vo.codiceSoggetto = dto.identificativoSoggetto;
    vo.tipoSoggetto = dto.tipoSoggetto;
    vo.denominazioneSoggetto = dto.denominazioneSoggetto;
    vo.tipoRecapito = dto.tipoRecapito;
    vo.denominazioneRecapito = dto.identificativoRecapito;
    vo.descrizioneRecapito = dto.descrizioneRecapito;
    if (dto.soggettoPadre) {
      vo.soggettoPadre = this.convertDtoToVo(dto.soggettoPadre);
    }
    if (dto.listaSoggettiRecapito) {
      vo.listaSoggettiRecapito = this.convertiSoggettiConStessoRecapito(
        dto.listaSoggettiRecapito
      );
    }
    vo.statoSoggetto = dto.statoSoggetto;
    return vo || new EntitaAnagrafeVO();
  }

  convertiSoggetto(dto: SoggettoAnagrafeDTO): EntitaAnagrafeVO {
    const vo: EntitaAnagrafeVO = new EntitaAnagrafeVO();

    vo.idSoggetto = dto.id;
    vo.codiceSoggetto = dto.dettaglioSoggetto.codice;
    vo.denominazioneSoggetto = dto.denominazione;
    vo.tipoSoggetto = dto.tipo;
    if (dto.recapiti.length > 0) {
      vo.idRecapito = dto.recapiti[0].id;
      vo.denominazioneRecapito = dto.recapiti[0].denominazione;
      vo.descrizioneRecapito = dto.recapiti[0].descrizione;
      vo.tipoRecapito = dto.recapiti[0].tipo;
      vo.tipo = dto.recapiti[0].tipo;
    }
    vo.soggettoPadre = null;
    vo.listaSoggettiRecapito = null;

    return vo;
  }

  convertiSoggettiConStessoRecapito(
    listaDTO: SoggettoAnagrafeDTO[]
  ): EntitaAnagrafeVO[] {
    const listaVO: EntitaAnagrafeVO[] = [];
    // console.log("convertiSoggettiConStessoRecapito", listaDTO);
    listaDTO.forEach((dto) => {
      const vo: EntitaAnagrafeVO = this.convertiSoggetto(dto);
      listaVO.push(vo);
    });
    return listaVO;
  }

  convertListVoToDto(e: EntitaAnagrafeVO[]): EntitaAnagrafeEstesaDTO[] {
    throw new Error("Method not implemented.");
  }

  convertListDtoToVo(
    entitaAnagrafeDTOList: EntitaAnagrafeEstesaDTO[]
  ): EntitaAnagrafeVO[] {
    const entitaAnagrafeVOList = new Array<EntitaAnagrafeVO>();
    entitaAnagrafeDTOList.forEach((entitaAnagrafeDTO) => {
      const entitaAnagrafeVO = this.convertDtoToVo(entitaAnagrafeDTO);
      entitaAnagrafeVOList.push(entitaAnagrafeVO);
    });
    // console.log("entitaAnagrafeVOList: ", entitaAnagrafeVOList);
    return entitaAnagrafeVOList || new Array<EntitaAnagrafeVO>();
  }
}
